import axios from 'axios'
import * as types from './mutation-types'
import authApi from '../../endpoints/auth'
import store from '@/store'

export const actions = {

    async signUp({ commit, dispatch, getters, rootGetters }, payload) {

        commit(types.USER_CREATE_LOADING)

        const { data } = await authApi.createUser({
            email: payload.email,
            telephone: `${payload.prefix}${payload.telephone}`,
            firstname: payload.firstname,
            lastname: payload.lastname,
            password: payload.password,
            mpassword: payload.mpassword,
            activation: payload.activation
        })

        if (data.hcode === "ko") {
            commit(types.USER_CREATE_ERROR, { error: error, data: null })
            return
        }

        commit(types.USER_CREATE_COMPLETE, payload)

        return data
    },

    async verifyPhoneNumber({ commit }, payload) {

        commit(types.VERIFY_PHONE_NUMBER_LOADING)

        const { data } = await authApi.verifyPhoneNumber({
            username: payload.username,
            code: payload.code,
        })

        if (data.hcode === "ko") {
            commit(types.VERIFY_PHONE_NUMBER_ERROR, { error: error, data: null })
            return
        }

        commit(types.VERIFY_PHONE_NUMBER_COMPLETE, payload)

        return data
    },

    async login({ commit }, payload) {

        commit(types.LOGIN_LOADING)

        let username = payload.showPrefix ? `${payload.prefix}${payload.username}` : payload.username

        const { data } = await authApi.getToken({
            username: username,
            password: payload.password,
        })

        if (data.hcode === "ko") {            
            commit(types.LOGIN_ERROR, { error: error, data: null })
            localStorage.removeItem('token')
            return
        }        

        const token = data.data.data.oapp_token

        localStorage.setItem('token', token) 

        if (token) {
            axios.defaults.headers.common['X-App-Token'] = token
            axios.defaults.headers.common['Authorization'] = token
        }

        commit(types.LOGIN_COMPLETE, data.data.data)

        if(data.data.data.shopsInfo.length > 0) {
            let shop_id = data.data.data.shopsInfo[0].oid
            //store.commit('shops/SHOP_DETAIL_COMPLETE', data.data.data.shopsInfo)
            await store.dispatch('shops/shopDetail', shop_id)
        }        
        
        await store.dispatch('shops/getShops')

        return data
    },

    async resetPassword({ commit }, payload) {

        commit(types.RESET_PASSWORD_LOADING)

        const { data } = await authApi.resetPassword({
            username: payload.username
        })

        if (data.hcode === "ko") {            
            commit(types.RESET_PASSWORD_ERROR, { error: error, data: null })
            return
        }

        commit(types.RESET_PASSWORD_COMPLETE, data.data)

        return data
    },

    async resetPasswordSendCode({ commit }, payload) {

        commit(types.RESET_PASSWORD_LOADING)

        const { data } = await authApi.resetPasswordSendCode({
            username: payload.username,
            code: payload.code,
            password: payload.password
        })

        if (data.hcode === "ko") {            
            commit(types.RESET_PASSWORD_ERROR, { error: error, data: null })
            return
        }

        commit(types.RESET_PASSWORD_COMPLETE, data.data)

        return data
    }

}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/auth/actions.js
// module id = null
// module chunks = 